import past1 from "../../assets/images/program_1.jpg";
import past2 from "../../assets/images/program_2.jpg";
import program3 from "../../assets/images/program_3.jpg";
import program4 from "../../assets/images/program_4.jpg";
import program5 from "../../assets/images/program_5.jpg";
import program6 from "../../assets/images/program_6.jpeg";
import program7 from "../../assets/images/program_7.jpeg";
import program8 from "../../assets/images/program_8.jpeg";
import program9 from "../../assets/images/program_9.jpeg";
import program10 from "../../assets/images/program_10.jpeg";
import program11 from "../../assets/images/program_11.jpeg";
import program12 from "../../assets/images/program_12.jpg";
import program13 from "../../assets/images/program_13.jpg";

export const programsData = [
  {
    id: 1,
    name: "FCPS-2 CRSH COURSE For EXTENTED TOACS",
    courseCoordinator: "Prof. Safia Sultana",
    registrationFee: "5,000",
    endDate: "2025-09-16",
    image: program4,
    description:
      "Simulated Patient Tasks, Skill Demonstration, Case Based Dicussion, Critical Appraisal",
  },
  {
    id: 2,
    name: "AI MEETS PREZI",
    courseCoordinator: "Dr. M Suleman Sadiq Hashmi",
    registrationFee: "2,000",
    endDate: "2025-09-04",
    image: program3,
    description:
      "Demonstrate how AI can assist in generating outlines, visuals, and teaching content.",
  },
  {
    id: 3,
    name: "Maintianing Confidentiality: Ethical & Legal Boundries",
    courseCoordinator: "Dr. Mustafa Aslam",
    registrationFee: "2,000",
    endDate: "2025-08-19",
    image: past1,
    description:
      "Understandiing of Legal ethical & professional obligations regarding provacy and confidentiality",
  },
  {
    id: 4,
    name: "The ART OF ASKING SMART QUESTIONS",
    courseCoordinator: "Prof. Dr. M. SHABAZ ARIF UK",
    registrationFee: "2,000",
    endDate: "2025-08-21",
    image: past2,
    description: "Precision, Relevance and Respect in Academic Forums",
  },
  {
    id: 5,
    name: "BIOCON'25, 1st Annual Conference of SOMCB",
    courseCoordinator: "Prof. Dr. Amila Jaleel",
    registrationFee: "1,000",
    endDate: "2025-10-16",
    image: program5,
    description:
      "Preconference Workshop Learn Smarter not Harder: AI IN BIOCHEMISTRY EDUCATION",
  },
  {
    id: 6,
    name: "9th International Conference on Health Professions Education | 1ICNM",
    courseCoordinator:
      "Medical Lecturer Anisa Ahmad, HOD Medical Education Noori-i-Kiran",
    registrationFee: "",
    endDate: "2025-10-24",
    image: program6,
    description:
      "Workplace-Based Learning: Structured Approaches to Experiential Training for Self-Assessment in Medical Education",
  },
  {
    id: 7,
    name: "WorkShop on Art of Making Your Quantative Research Understanable",
    courseCoordinator: "Arslan Saleem Chugtai",
    registrationFee: "2,000",
    endDate: "2025-10-27",
    image: program7,
    description: "Art of Making Your Quantative Research Understanable",
  },
  {
    id: 8,
    name: "Development of Planners",
    courseCoordinator: "Prof.Dr.Anila Jaleel",
    registrationFee: "1,000",
    endDate: "2026-01-16",
    image: program8,
    description:
      "Enhance and Orient Faculty Memeber skills in curriculum organization, documentation and effective academic planning",
  },
  {
    id: 9,
    name: "CPD Workshop Construction of PBL",
    courseCoordinator: "Prof.Dr.Anila Jaleel",
    registrationFee: "1,000",
    endDate: "2026-01-20",
    image: program9,
    description:
      "To Construct PBL with integration of Basic and Clinical subjects",
  },
  {
    id: 10,
    name: "CPD-1 Workshop PBL Case Files",
    courseCoordinator: "Prof.Sarah Khalid",
    registrationFee: "1,000",
    endDate: "2026-01-22",
    image: program10,
    description:
      "To Construct PBL with integration of Basic and Clinical subjects",
  },
  {
    id: 11,
    name: "CPD Workshop",
    courseCoordinator: "Prof.Dr.Adeela Shahid",
    registrationFee: "1,000",
    endDate: "2026-01-29",
    image: program11,
    description:
      "INTO PEER REVIEW: WRITING ARTICLES THAT MEET SCHOLARLY STANDARDS",
  },
  {
    id: 12,
    name: "Pre-Conference Workshop",
    courseCoordinator: "Ms. Aqsa Yasin and Mr. Muhammad Waseem Tariq",
    registrationFee: "2,000",
    endDate: "2026-01-30",
    image: program12,
    description:
      "SMARTER CT IMAGING: AI-ENABLED ACQUISITION AND ADVANCED POST-PROCESSING ON VITREA WORKSTATION",
  },
  {
    id: 13,
    name: "Pre-Conference Workshop",
    courseCoordinator: "Dr. Junaid Saleem",
    registrationFee: "2,000",
    endDate: "2026-02-04",
    image: program13,
    description:
      "COMPREHENSIVE ACL REHAB IN ATHLETES: FROM SURGERY TO SPORT-READY",
  },
];

export const getCurrentPrograms = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day

  const current = programsData.filter((program) => {
    const endDate = new Date(program.endDate);
    endDate.setHours(23, 59, 59, 999);
    return endDate >= today;
  });

  console.log("Current programs:", current);
  return current;
};

export const getPastPrograms = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day

  const past = programsData.filter((program) => {
    const endDate = new Date(program.endDate);
    endDate.setHours(23, 59, 59, 999); // Set to end of day
    return endDate < today;
  });

  console.log("Past programs:", past);
  return past;
};
